import { createContext } from 'react';

import type { ContextType } from './types';

export const DatadogRumContext = createContext<ContextType | null>(null);
